<template>
  <div class="add-inter-follow-dialog">
    <v-form ref="form">
      <div class="my-steper" vertical>
        <v-card-title>
          {{ $t("addInterFollow.create") }}
        </v-card-title>

        <v-card-text>
          <div class="inter-follow-field">
            <p class="inter-follow-field-title">
              <v-icon> mdi-magnify </v-icon>
              {{ $t("addInterFollow.type_users") }}
            </p>
          </div>

          <v-autocomplete
            id="add-inter-followed-type-filter"
            :items="userTypes"
            item-value="userTypes"
            item-text="userTypes"
            :label="$t('addInterFollow.type_users')"
            persistent-hint
            single-line
            multiple
            chips
            deletable-chips
            :clearable="true"
            filled
            v-model="userTypesSelected"
          >
          </v-autocomplete>

          <div class="inter-follow-field">
            <p class="inter-follow-field-title">
              <v-icon> mdi-magnify </v-icon>
              {{ $t("addInterFollow.city") }}
            </p>
          </div>

          <v-autocomplete
            id="add-inter-followed-city-filter"
            :items="locations"
            item-value="city"
            item-text="city"
            :label="$t('addInterFollow.city')"
            persistent-hint
            single-line
            multiple
            chips
            deletable-chips
            :clearable="true"
            filled
            v-model="locationsNamesSelected"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.item.city"
                close
                @click:close="removeChip(data.item)"
                :style="setStyleforCity(data.item)"
              >
                {{ data.item.city }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content :style="setStyleforCity(data.item)">
                <div class="inter-follow-list-item-title">
                  {{ data.item.city }}
                </div>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <div class="inter-follow-field">
            <p class="inter-follow-field-title">
              <v-icon> mdi-account-multiple-plus </v-icon>
              {{ $t("addInterFollow.users") }}
            </p>
          </div>

          <v-autocomplete
            id="intervention-add-event"
            :items="usersSelected"
            item-text="fullname"
            :label="$t('addInterFollow.users')"
            persistent-hint
            single-line
            multiple
            chips
            deletable-chips
            :clearable="true"
            filled
            return-object
            v-model="usersToAssign"
          >
            <template #item="{ item, on, attrs }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.fullname }} - {{ item.details.type }} -
                    {{ item.location }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-card-actions>
            <v-btn
              color="success"
              @click="addInterventionFollowed"
              id="create-inter-follow-event"
            >
              <div>
                {{ $t("addInterFollow.create_button") }}
              </div>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </div>
    </v-form>
    <div v-if="errors" class="interFollowErrors">
      <p class="errors">
        {{ $t("addInterFollow.creationError") }} : {{ listOfErrorNames }}
      </p>
      <!-- <ul class="errors errorsList">
          <li v-for="names in usersFailure" :key="names">{{ names }}</li>
        </ul> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventModule from "@/store/planning/eventStore";
import InterventionFollowedModule from "@/store/planning/interventionFollowedStore";
import LeavePeriodModule from "@/store/planning/leavePeriodStore";

export default {
  props: {
    interventionToFollow: null,
  },
  data() {
    return {
      userTypes: [],
      usersSelected: [],
      locationsNamesSelected: [],
      userTypesSelected: [],
      usersToAssign: [],
      listOfErrorNames: [],
      errors: false,
    };
  },
  computed: {
    ...mapGetters("userModule", { users: "getUsersExisting" }),
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
  },

  async mounted() {
    this.$enumUserType.forEach((element) => {
      if (
        element.value !== "INTERVNOTASSIGN" &&
        element.value !== "NOTFOUND"
      ) {
        this.userTypes.push(element.value);
      }
    });
    this.usersSelected = this.users;
  },

  watch: {
    userTypesSelected: function () {
      this.setUsersSelected();
    },

    locationsNamesSelected: function () {
      this.setUsersSelected();
    },
  },

  methods: {
    ...mapActions("interventionFollowedModule", ["createInterventionFollowed"]),
    ...mapActions("notificationModule", ["emptyErrorMessages"]),
    setUsersSelected() {
      if (
        this.userTypesSelected.length === 0 &&
        this.locationsNamesSelected.length === 0
      ) {
        this.usersSelected = this.users;
      } else {
        let tempUsers = this.setUserByType();
        this.usersSelected = this.setUserByCity(tempUsers);
      }
    },
    setUserByType() {
      let result = [];
      if (this.userTypesSelected.length === 0) {
        result = this.users;
      } else {
        this.userTypesSelected.forEach((type) => {
          let tempUsers = this.users.filter((u) => u.types.includes(type));
          tempUsers.forEach((u) => result.push(u));
        });
      }
      return result;
    },
    setUserByCity(listToFilter) {
      let result = [];
      if (this.locationsNamesSelected.length === 0) {
        result = listToFilter;
      } else {
        this.locationsNamesSelected.forEach((city) => {
          let tempUsers = listToFilter.filter((u) => u.location === city);
          tempUsers.forEach((u) => result.push(u));
        });
      }
      return result;
    },
    addInterventionFollowed() {
      let interventionFollowed = {
        userDto: { id: null },
        advInterventionDto: { id: this.interventionToFollow.details.id },
      };
      let everythingValid = true;
      this.errors = false;
      this.listOfErrorNames = "";
      this.emptyErrorMessages();

      this.usersToAssign.forEach((user) => {
        if (
          !(
            EventModule.methods.intervalIsEmpty(
              this.interventionToFollow.x,
              this.interventionToFollow,
              user
            ) &&
            InterventionFollowedModule.methods.intervalIsEmptyInterventionFollowed(
              this.interventionToFollow.x,
              this.interventionToFollow,
              user
            ) &&
            LeavePeriodModule.methods.intervalIsEmptyLeavePeriod(
              this.interventionToFollow.x,
              this.interventionToFollow,
              user
            )
          )
        ) {
          everythingValid = false;
          this.listOfErrorNames += user.fullname + ", ";
        }
      });

      if (everythingValid) {
        this.usersToAssign.forEach((user) => {
          interventionFollowed.userDto.id = user.id;
          this.createInterventionFollowed(interventionFollowed);
        });
        this.closeEvent();
      } else {
        this.listOfErrorNames = this.listOfErrorNames.slice(0, -2);
        setTimeout(() => {
          this.errors = true;
        }, 200);
      }
    },
    closeEvent() {
      this.errors = false;
      this.listOfErrorNames = "";
      this.userTypesSelected = [];
      this.locationsNamesSelected = [];
      this.usersToAssign = [];
      this.$emit("close");
    },
    removeChip(item) {
      const index = this.locationsNamesSelected.indexOf(item.city);
      if (index >= 0) this.locationsNamesSelected.splice(index, 1);
    },
    setStyleforCity(location) {
      return {
        backgroundColor: location.color,
        color: "white",
        fontWeight: "bold",
      };
    },
  },
};
</script>

<style lang="scss">
.add-inter-follow-dialog {
  border-radius: 50px;
  height: 100%;
  overflow: auto;

  .v-form {
    .my-steper {
      height: 100%;
      background: none;
      box-shadow: none;

      .v-card__title {
        text-align: center;
        justify-content: center;
        color: white;
        background-color: #1975d2;
      }
    }
  }

  button {
    margin: 0 10px 0 0;
  }
}

.inter-follow-field-title {
  padding: 10px 10px;
  font-weight: bold;
}

.inter-follow-field {
  display: flex;
}

.inter-follow-list-item-title {
  padding: 5px 10px;
}

.errors {
  color: red;
  width: 100%;
  text-align: center;
}

.errorsList {
  list-style-type: none;
  width: 100%;

  li {
    display: inline;
    text-align: center;
    padding-right: 5px;
  }
}

.interFollowErrors {
  text-align: center;
  justify-content: center;
}
</style>
